import { useCallback } from 'react';

import { isBrowser } from '@lucid/utils';

const useUrlParamUpdate = (param: string) =>
  useCallback(
    (value: string) => {
      if (!isBrowser()) return;

      const url = new URL(window.location.href);

      if (value === '') {
        url.searchParams.delete(param);
      } else {
        url.searchParams.set(param, value);
      }

      window.history.replaceState({ path: url.href }, '', url.href);
    },
    [param],
  );

export default useUrlParamUpdate;
